export class LocalStorageConstant {
  public static readonly USER_TOKEN = 'USER_TOKEN';
  public static readonly FIREBASE_USER_CREDENTIAL = 'FIREBASE_USER_CREDENTIAL';

  public static readonly LOGOUT_EVENT = 'LOGOUT_EVENT';
}
